import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StylesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Styles",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.56 28.02c.19-.13.34-.3.46-.5.37-.59.59-1.27.63-1.97.32-3.24 2.88-5.14 5.24-3.54s2.73 4.61-.07 6.23q-.69.405-1.44.69H7.3c-.89.35-1.82.61-2.77.78h-.09c-.44.09-.89.15-1.34.2h-.09c-.57 0-1.03-.46-1.03-1.03 0-.38.22-.73.55-.91V28Zm10.87-4.99c-.39.4-1.04.4-1.43 0l-2.85-2.88c-.19-.19-.3-.45-.3-.73 0-.57.45-1.03 1.01-1.04.28 0 .55.11.75.31l2.83 2.88a1.037 1.037 0 0 1-.01 1.47Zm-2.41-5.93L24.79 3.26a2.887 2.887 0 0 1 4.03-.62c1.28.94 1.56 2.74.62 4.03-.17.24-.38.44-.61.62L15 21.12z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8 19.429a5.72 5.72 0 0 0-5.714 5.714v3.429H1.143a1.142 1.142 0 1 0 0 2.285H8c3.151 0 5.715-2.563 5.715-5.714S11.15 19.429 8 19.429m0 9.143H4.572v-3.429c0-1.89 1.538-3.429 3.428-3.429s3.429 1.538 3.429 3.429S9.891 28.572 8 28.572"
      }), /*#__PURE__*/_jsx("path", {
        d: "m30.998 3.449-1.303-1.304a3.413 3.413 0 0 0-4.62-.21l-.002.001-14.672 12.24a3.432 3.432 0 0 0-.228 5.058l3.736 3.736a3.44 3.44 0 0 0 2.578 1.001 3.44 3.44 0 0 0 2.478-1.229L31.205 8.07a3.414 3.414 0 0 0-.207-4.621M17.21 21.278a1.13 1.13 0 0 1-.826.41c-.322-.006-.63-.105-.859-.334l-3.735-3.737a1.12 1.12 0 0 1-.334-.858 1.13 1.13 0 0 1 .41-.827l2.65-2.211 4.906 4.907zM29.451 6.606l-8.703 10.432-4.643-4.643 10.431-8.703a1.14 1.14 0 0 1 1.541.07l1.304 1.303c.422.42.45 1.084.07 1.541"
      })]
    })
  }));
};
StylesIcon.displayName = 'StylesIcon';